<script>
/**
 * 函数式组件：渲染菜单项的图标 + 标题
 * 图标来源：
 *  1. svg-icon（项目里有该全局组件）
 *  2. 'el-icon-' 开头的 Element 字体图标
 */
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon']} />)
      } else {
        vnodes.push(<svg-icon icon-class={icon} class="sidebar-svg-icon" />)
      }
    }

    if (title) {
      vnodes.push(<span slot="title">{title}</span>)
    }

    return vnodes
  }
}
</script>

<style lang="scss" scoped>
.sub-el-icon {
  margin-right: 12px;
  margin-left: -2px;
  width: 16px;
  font-size: 16px;
  text-align: center;
  vertical-align: middle;
}

.sidebar-svg-icon {
  margin-right: 12px;
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
</style>